import { createAsyncThunk } from '@reduxjs/toolkit';
import type { TAppDispatch, TRootState } from './store';

export const createAppAsyncThunk = createAsyncThunk.withTypes<{
  state: TRootState;
  dispatch: TAppDispatch;
}>();
